$(document).on 'turbo:load', ->
  new App.lessonsAll() if $(".lessonsShowView, .lessonActivitiesIndexView").length

class @App.lessonsAll
  constructor: ->
    @loadCarousel()
    @checkForFeedback()
    @panelScrollCheck()
    @bindElements()
    @bindModalInvitation()
    @bindLogView()
    @bindLessonToolbar()
    @$videoContainer = $(".videoContainer")
    new CollapsibleBehavior()

  loadCarousel: ->
    if $(".carouselContainer.review").length
      $(".carouselContainer.review").carouFredSel
        auto: false
        circular: false
        infinite: false
        items:
          visible: 1
        scroll:
          items: 1
          fx: "scroll"
          duration: 350
          easing: "easeOutQuart"
          onAfter: (data) ->
            # @panelScrollCheck() # I'm not sure what this does?
            if $(this).triggerHandler("currentVisible").hasClass("hasFeedback")
              $(this).triggerHandler("currentVisible").find(".mark-feedback-read-trigger").click()

            $el = $(".panel.review")
            url  = $el.data('url')
            currentPanel = $el.find(".uiCycleNav").find(".selected").index() + 1
            History.pushState(null , null, url+'#question-'+currentPanel)

        prev:
          button: ".panel.review .actionLeft"
          key: null
        next:
          button: ".panel.review .actionRight"
          key: null
        pagination: ".panel.review .topNav .uiCycleNav"
      ,
        debug: false
      if $(".carouselContainer.review").triggerHandler("currentVisible").hasClass("hasFeedback")
        $(".carouselContainer.review").triggerHandler("currentVisible").find(".mark-feedback-read-trigger").click()

  checkForFeedback: ->
    carousel = $(".carouselContainer.review")
    nav = $(".uiCycleNav")
    $(".uiCycleNav").find("a").each ->
      index = $(this).index()
      item = carousel.find("*[data-position=\"" + index + "\"]")
      if item.hasClass("hasFeedback")
        $(this).addClass('hasFeedback')
        $(this).addClass(item.attr('id'))

  panelScrollCheck: ->
    $el = $(".panel.review")
    $next = $el.find(".actionRight")
    $prev = $el.find(".actionLeft")
    panelOrigin = 1
    currentPanel = $el.find(".uiCycleNav").find(".selected").index() + 1
    panelCount = $el.find(".item").length
    if currentPanel is panelOrigin
      $prev.fadeOut "300"
      $next.fadeIn "300", "easeOutQuart"
    else if currentPanel is panelCount
      $prev.fadeIn "300", "easeOutQuart"
      $next.fadeOut "300"
    else
      $prev.fadeIn "300", "easeOutQuart"
      $next.fadeIn "300", "easeOutQuart"

  ###
  General binding of event to els on page.
  ###
  bindElements: ->
    self = this

    # Live events for elements in panels
    $("#panels").on "click.lessonsAll", ".nextQ a", (e) ->
      $panel = $(this).parents(".panel")
      e.preventDefault()
      $panel.find("button.actionRight").click()
      $panel.find(".flashMessages").hide().find(".flash").hide()

    $("#panels").on "click.lessonsAll", ".nextS a", (e) ->
      $panel = $(this).parents(".panel")
      e.preventDefault()
      self.nextPanel()
      $panel.find(".flashMessages, .flash").hide()

    $("#panels").on "click.lessonsAll", "button.try, .uiCycleNav a", (e) ->
      $panel = $(this).parents(".panel")
      e.preventDefault()
      $panel.find(".flashMessages").hide().find(".flash").hide()

    $("#panels").on "click.lessonsAll", "div.a label", (e) ->
      $(this).parents(".as").find(".selected").removeClass("selected").end().end().parents(".a").addClass "selected"


  bindModalInvitation: ->
    # share-via-email form
    $(document).on "ajax:success ajax:error", "#new_invitation", (e) ->
      # This assume a jQuery event with e.type defined as "ajax:success" or "ajax:error"
      @shareViaEmailStateChange e.type

    $(document).on "click.lessonsAll", "#new_invitation .send-again", (e) ->
      @shareViaEmailSendAgain(e)

    $(document).on "click.lessonsAll", "#new_invitation .emailForm", (e) ->
      @validateEmailForm(e)

  bindLessonToolbar: ->
    $(".nav-toolbar .share-lesson").on "click", (e) =>
      targetUrl      = $(e.currentTarget).attr('data-url')
      method         = $(e.currentTarget).attr('data-method')
      confirmMessage = $(e.currentTarget).attr('data-confirm')

      return if targetUrl == '#'

      if (typeof(confirmMessage) == 'undefined' || confirm(confirmMessage))
        $.ajax
          type: method
          url: targetUrl
          dataType: 'script'

      return false

  ###
  Event Handler to shift to the next panel
  @param  {Object} e Event (jquery) object.
  @param  {String} [caller] A string telling who is calling this event.
  @return {Boolean}
  ###
  nextPanel: (e, caller) ->
    $next = $('.uiToggleSwitch .active').parents('li').next('li').children('a')
    return false if caller is "videoState" and @$videoContainer.is(".isRight")
    $next.click()

  validateEmailForm: (e) ->
    e.preventDefault()
    unless $("#emailToField").val()
      $("#emailToField").focus()
      $("#new_invitation").find(".FormError").hide()
      $("#new_invitation").find(".formEmailBlank").show().delay(4000).fadeOut "slow"
    else
      emails = $("#emailToField").val().replace(RegExp(" ", "g"), "").split(",")
      count = emails.length
      email_check = /@/i
      go = true

      # TO DO: ujs refactor
      # Looping through emails should be handed server side in the controller.
      $.each emails, (i) ->
        unless email_check.test(this)
          go = false
          $("#new_invitation").find(".FormError").hide()
          $("#new_invitation").find(".formEmailFix").show().delay(4000).fadeOut "slow"
        if not --count and go is true
          $("#new_invitation").get(0).requestSubmit()
          $("#new_invitation").find(".FormError").hide()


  shareViaEmailSendAgain: (e) ->
    e.preventDefault()
    $("#new_invitation").find(".send-again").hide()
    $("#new_invitation").find(".emailForm").show()
    $("#new_invitation").find(".formConfirmationSuccess").hide()

  ###
  Ajax handler for the share-via-email form.
  ###
  shareViaEmailStateChange: (eventType) ->
    button = $("#new_invitation").find("button.emailForm")
    switch eventType
      when ("ajax:success")
        button.hide().siblings("button.send-again").show()
        $("#new_invitation").find(".formConfirmationSuccess").show()
      when ("ajax:error")
        $("#new_invitation").find(".formConfirmationError").show().delay(4000).fadeOut "slow"

  _toggleClassAct: (e) ->
    $t = $(this)
    opening = $t.hasClass("flip")
    e.preventDefault()
    $t.toggleClass "flip"

    # open/close the panels
    $("#classAct").find(".panels").slideToggle 450, "easeInOutExpo"

    # scroll the page down if opening
    if opening
      $.scrollTo "+=350",
        axis: "y"
        duration: 450
        easing: "easeInOutExpo"


  triggerEvent: (eventName, addArgs) ->
    bod = @_bod or (@_bod = $(document.body))
    types = undefined
    types = $.trim(eventName).split(" ")
    $.each types, (i, type) ->
      bod.trigger type, addArgs

    this

  bindLogView: ->
    $(".uiToggleSwitch").click =>
      @logView()

  logView: ->
    # only log views on the lesson/show page
    return  if $(".lessonsShowView").length is 0

    # only log views once
    return  if $(document.body).data("viewLogged") is true

    split_path = window.location.pathname.split('/')
    path_prefix = split_path[1] # This could be 'on' or 'lessons'
    lesson_id = split_path[2]
    url = '/lesson_views?lesson_id=' + lesson_id
    $.ajax {
      type: "POST"
      url: url
      dataType: "script"
      beforeSend: (xhr) ->
        xhr.setRequestHeader "X-CSRF-Token",
                              $("meta[name=\"csrf-token\"]").attr("content")
    }

    # let's only do this once
    $(document.body).data "viewLogged", true

  logEnded: ->
    # only log ended on the lesson/show page
    return  if $(".lessonsShowView").length is 0

    # only log ended once
    return  if $(document.body).data("endedLogged") is true

    split_path = window.location.pathname.split('/')
    path_prefix = split_path[1] # This could be 'on' or 'lessons'
    lesson_id = split_path[2]
    url = '/lesson_activities/completed?lesson_id=' + lesson_id
    $.ajax {
      type: "POST"
      url: url
      dataType: "script"
      beforeSend: (xhr) ->
        xhr.setRequestHeader "X-CSRF-Token",
                              $("meta[name=\"csrf-token\"]").attr("content")
    }

    # let's only do this once
    $(document.body).data "endedLogged", true
